export default "__VITE_ASSET__Dv5_DoV3__"